import { render, staticRenderFns } from "./w-btn-user.vue?vue&type=template&id=433719aa&lang=pug&"
import script from "./w-btn-user.vue?vue&type=script&lang=js&"
export * from "./w-btn-user.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433719aa')) {
      api.createRecord('433719aa', component.options)
    } else {
      api.reload('433719aa', component.options)
    }
    module.hot.accept("./w-btn-user.vue?vue&type=template&id=433719aa&lang=pug&", function () {
      api.rerender('433719aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-user.vue"
export default component.exports